export default __webpack_public_path__ + "static/media/flag-united-arab-emirates.aa147936.svg";